export default __webpack_public_path__ + "static/CenturyExpanded-Roman-0e77e1349147ea2296766ebce1709fc0.woff2";